import { useParams, useNavigate } from "react-router-dom";
import { useQuizAttempts } from "@/hooks/Quizzes/useQuizzes";
import { Loader2, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUser } from "@/contexts/UserContext";

export default function QuizAttempts() {
  const navigate = useNavigate();
  const { courseId, moduleId, quizId } = useParams();
  const { user } = useUser();

  const numericCourseId = Number(courseId);
  const numericModuleId = Number(moduleId);
  const numericQuizId = Number(quizId);

  const { attempts, isLoading, isError } = useQuizAttempts(
    numericCourseId,
    numericModuleId,
    numericQuizId,
    user.id
  );

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    );
  }

  if (isError || !attempts) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="text-center">
          <p className="text-lg font-medium">No se encontró el resultado del intento.</p>
          <Button className="mt-4" onClick={() => navigate("/courses/" + courseId)}>
            Volver
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6 bg-background">
      <div className="max-w-3xl mx-auto space-y-4">
        <div className="flex items-center gap-3">
          <Button variant="ghost" onClick={() => navigate("/courses/" + courseId)}>
            <ArrowLeft className="h-4 w-4 mr-2" /> Volver
          </Button>
        </div>

        <h1 className="text-2xl font-bold">Resultados de Exámenes</h1>

        {
          attempts.length === 0 ? (
            <p className="text-center text-muted-foreground">Aún no has realizado ningún intento.</p>
          ) : (
            attempts.map((attempt) => (
              <div key={attempt.id} className="bg-card border rounded-lg p-6 mb-4">
                <p className="text-sm text-muted-foreground">Calificación</p>
                {
                  attempt.passed ? (
                    <>
                      <div className="text-4xl font-bold ">{attempt.score}%</div>
                      <p className="text-lg mt-2 text-green-600 underline">Aprobado</p>
                    </>
                  ) : (
                    <>
                      <div className="text-4xl font-bold text-primary">{attempt.score}%</div>
                      <p className="text-lg mt-2 text-red-600">Reprobado</p>
                    </>
                  )
                }
                <p className="text-xs text-muted-foreground mt-3">Intento realizado: {new Date(attempt.attemptedAt).toLocaleString()}</p>
              </div>
            )))
        }
      </div>
    </div>
  );
}
